import * as React from "react";
import type { SVGProps } from "react";
const SvgMove = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.707 9.707a1 1 0 0 0-1.414-1.414zM2 12l-.707-.707a1 1 0 0 0 0 1.414zm2.293 3.707a1 1 0 0 0 1.414-1.414zm4-11.414a1 1 0 0 0 1.414 1.414zM12 2l.707-.707a1 1 0 0 0-1.414 0zm2.293 3.707a1 1 0 1 0 1.414-1.414zm1.414 14a1 1 0 0 0-1.414-1.414zM12 22l-.707.707a1 1 0 0 0 1.414 0zm-2.293-3.707a1 1 0 0 0-1.414 1.414zm10-10a1 1 0 1 0-1.414 1.414zM22 12l.707.707a1 1 0 0 0 0-1.414zm-3.707 2.293a1 1 0 0 0 1.414 1.414zm-14-6-3 3 1.414 1.414 3-3zm-3 4.414 3 3 1.414-1.414-3-3zm8.414-7 3-3-1.414-1.414-3 3zm1.586-3 3 3 1.414-1.414-3-3zm3 15.586-3 3 1.414 1.414 3-3zm-1.586 3-3-3-1.414 1.414 3 3zm5.586-11.586 3 3 1.414-1.414-3-3zm3 1.586-3 3 1.414 1.414 3-3zM2 13h20v-2H2zm9-11v20h2V2z"
    />
  </svg>
);
export default SvgMove;
